import { Dimensions } from 'react-native';
import DeviceInfo from 'react-native-device-info';

let brand = DeviceInfo.getBrand();
export const convertTime = (time) => {
  const hors = Math.floor(time / 60 / 60);
  let min = Math.floor((time - hors * 60 * 60) / 60);
  let sec = time - hors * 60 * 60 - min * 60;
  if (min < 10) {
    min = `0${min}`;
  }
  if (sec < 10) {
    sec = `0${sec}`;
  }
  return `${hors}:${min}:${sec}`;
};

export const ncFileStatuses = {
  PartiallyLinked: 'PartiallyLinked',
  Linked: 'Linked',
  Unknown: 'Unknown',
  Unlinked: 'Unlinked',
  Undefined: 'Undefined',
  Ignored: 'Ignored',
  Change: 'Change',
  Setup: 'Setup',
};

export const machineStatuses = {
  ACTIVE: 'Active', // ACTIVE
  CHANGE: 'Change', // CHANGE
  SETUP: 'Setup', // SETUP
  NOTPRODUCTIVE: 'NotProductive', // NOT PRODUCTIVE
};

export const machineStatusName = {
  Active: 'Active', // ACTIVE
  Change: 'Change', // CHANGE
  Setup: 'Setup', // SETUP
  NotProductive: 'Not Productive', // NOT PRODUCTIVE
};

export const machineTimeType = {
  PAID: 'Paid',
  SCHEDULED: 'Scheduled',
  IDEAL: 'Ideal',
};

export const dotTimeIndicatorColor = {
  [machineTimeType.PAID]: 'Time/Light/Paid',
  [machineTimeType.SCHEDULED]: 'Time/Light/Scheduled',
  [machineTimeType.IDEAL]: 'Time/Light/Ideal',
};

export const machineStatusColorName = {
  [machineStatuses.ACTIVE]: 'Wallboard/Light/Active', // ACTIVE
  [machineStatuses.CHANGE]: 'Wallboard/Light/Change', // Change
  [machineStatuses.SETUP]: 'Wallboard/Light/Setup', // SETUP
  [machineStatuses.NOTPRODUCTIVE]: 'Status/Light/Not Productive', // NOT PRODUCTIVE
};

const minimumTileSizeToWord = {
  4: 'extra large',
  3: 'large',
  2: 'standard',
  1: 'small',
};

const verticalTilesConfig = {
  landscape: {
    'extra large': 1,
    large: 1,
    standard: 2,
    small: 3,
  },
  portrait: {
    'extra large': 1,
    large: 2,
    standard: 3,
    small: 4,
  },
};

const baseElementHeight = 342;

const targetSpacing = 12;

const widestTile = 0.842;
const tallestTile = 0.649;

let minStart = 1;
let maxStart = null;

export const gcd = (a, b) => {
  return b == 0 ? a : gcd(b, a % b);
};

export const getMyConfig = (machines, minimumTileSize, config) => {
  const c = config[minimumTileSizeToWord[minimumTileSize]];
  const { minTiles } = c;

  if (minimumTileSize === 4 || machines >= minTiles) {
    return c;
  } else {
    return getMyConfig(machines, minimumTileSize + 1, config);
  }
};

export const calculation = ({ base: { width, height }, size, orientation }) => {
  const verticalTiles = verticalTilesConfig[orientation][size];

  let tileHeight = Math.floor((height - targetSpacing * (verticalTiles + 1)) / verticalTiles);

  let top = Math.floor((height - (tileHeight * verticalTiles + (verticalTiles - 1) * targetSpacing)) / 2);
  let bottom = Math.floor(height - ((verticalTiles - 1) * targetSpacing + verticalTiles * tileHeight + top));

  const maxHorizTiles = (width - top) / (tileHeight * widestTile + top);
  const minHorizTiles = (width - top) / (tileHeight * tallestTile + top);

  const horizTiles = Math.ceil(maxHorizTiles);

  const additionalTopBottom = minHorizTiles < horizTiles;

  const tileWidth = Math.floor((width - targetSpacing) / horizTiles - targetSpacing);

  const left = Math.floor((width - (tileWidth * horizTiles + (horizTiles - 1) * targetSpacing)) / 2);
  const rigth = width - ((horizTiles - 1) * targetSpacing + horizTiles * tileWidth + left);

  const aspectRatio = tileWidth / tileHeight;

  if (additionalTopBottom) {
    tileHeight = Math.floor(tileWidth / tallestTile);
    top = Math.floor((height - (tileHeight * verticalTiles + (verticalTiles - 1) * targetSpacing)) / 2);
    bottom = height - ((verticalTiles - 1) * targetSpacing + verticalTiles * tileHeight + top);
  }

  let minTiles = maxStart ? maxStart + 1 : minStart;
  const maxTiles = verticalTiles * horizTiles;
  maxStart = maxTiles;

  return {
    minTiles,
    maxTiles,
    tileHeight,
    tileWidth,
    left,
    rigth,
    top,
    bottom,
    horizTiles,
    verticalTiles,
    scaleFactor: tileHeight / baseElementHeight,
  };
};

export const generateConfig = ({
  initialMachines,
  minimumTileSize,
  safeAreaInsetsBottom,
  safeAreaInsetsTop,
  safeAreaInsetsLeft,
  safeAreaInsetsRight,
}) => {
  let width = Dimensions.get(brand === 'google' ? 'screen' : 'window').width;
  let height = Dimensions.get(brand === 'google' ? 'screen' : 'window').height;

  const r = gcd(width, height);
  const ratio = (width / r / (height / r)).toFixed(2);
  const orientation = ratio >= 1 ? 'landscape' : 'portrait';

  height = height - safeAreaInsetsBottom - safeAreaInsetsTop;
  width = width - safeAreaInsetsLeft - safeAreaInsetsRight;

  const base = { width, height };
  const data = {};

  minStart = 1;
  maxStart = null;

  data['landscape'] = {
    'extra large': calculation({ base, orientation: 'landscape', size: 'extra large' }),
    standard: calculation({ base, orientation: 'landscape', size: 'standard' }),
    small: calculation({ base, orientation: 'landscape', size: 'small' }),
  };
  data['landscape'].large = data['landscape']['extra large'];

  minStart = 1;
  maxStart = null;

  data['portrait'] = {
    'extra large': calculation({ base, orientation: 'portrait', size: 'extra large' }),
    large: calculation({ base, orientation: 'portrait', size: 'large' }),
    standard: calculation({ base, orientation: 'portrait', size: 'standard' }),
    small: calculation({ base, orientation: 'portrait', size: 'small' }),
  };

  const c = getMyConfig(initialMachines.length, minimumTileSize, data[orientation]);

  return { c: { ...c, width, height, safeAreaInsetsBottom, safeAreaInsetsTop, safeAreaInsetsLeft, safeAreaInsetsRight }, orientation };
};

/**
 * Rounds a number to the nearest even integer.
 *
 * If the number is exactly between two integers (e.g., 7.5), it chooses the even one.
 * This is useful when you want to ensure the result is always an even number,
 * for alignment or pixel-perfect rendering purposes.
 */
export const roundToEven = (num) => {
  const floor = Math.floor(num);
  const ceil = Math.ceil(num);

  // Find which integer (floor or ceil) is closer to the original number
  if (Math.abs(num - floor) < Math.abs(num - ceil)) {
    // If floor is closer, return it if it's even, otherwise return ceil
    return floor % 2 === 0 ? floor : ceil;
  }

  // If ceil is closer or equally close, return it if it's even, otherwise return floor
  return ceil % 2 === 0 ? ceil : floor;
};

export const roundToOdd = (num) => {
  const floor = Math.floor(num);
  const ceil = Math.ceil(num);

  // Check which integer is closer to the number
  if (Math.abs(num - floor) < Math.abs(num - ceil)) {
    // Floor is closer: return it if odd, else return ceil
    return floor % 2 !== 0 ? floor : ceil;
  }

  // Ceil is closer or equally close: return it if odd, else return floor
  return ceil % 2 !== 0 ? ceil : floor;
};

export const buildProductionOperationFilter = (links = []) => {
  const filtersArray = links.reduce((acc, { productionOperationId }) => {
    if (productionOperationId) {
      acc.push(`ProductionOperationId eq ${productionOperationId}`);
    }
    return acc;
  }, []);

  return filtersArray.join(' or ');
};

export const subStatuses = {
  NotPingable: 'NotPingable',
  MachineConnectorOff: 'MachineConnectorOff',
  Offline: 'Offline',
  Running: 'Running',
  ConnectorOff: 'ConnectorOff',
  ConnectionOff: 'ConnectionOff',
  NoConnector: 'NoConnector',
  Idle: 'Idle',
  Stopped: 'Stopped',
  Interrupted: 'Interrupted',
  Active: 'Active',
  Checking: 'Checking',
  ConnectionFailed: 'ConnectionFailed',
};

export const subStatusName = {
  NotPingable: 'Not pingable',
  MachineConnectorOff: 'Machine connector off',
  Offline: 'Offline',
  ConnectionFailed: 'Connection Failed',
  Canceled: 'Canceled',
  Running: 'Running',
  ConnectorOff: 'Connector off',
  ConnectionOff: 'Connection Switched Off',
  NoConnector: 'No connector',
  Idle: 'Idle',
  Stopped: 'Stopped',
  Interrupted: 'Interrupted',
  Active: 'Active',
  Checking: 'Checking',
  Started: 'Started',
  ConnectorOffline: 'Connector offline',
  ConnectorOnline: 'Connector online',
  TryingToConnect: 'Trying to connect',
  NoNcFileSelected: 'No NC File selected',
  NotRunning: 'Not running',
};
